import cn from 'classnames';
import GuestPhoto from './GuestPhoto';
import GuestSection from './GuestSection';
import PricingItem from './PricingItem';
import Schedule from './Schedule';
import Disclaimer from './Disclaimer';
import { Anchor } from '../../../../shared/Anchor';
import s from './GuestProfile.module.scss';

function isShowPricing(pricing) {
  let show = false;

  Object.keys(pricing).forEach((key) => {
    if (pricing[key].length > 0) {
      show = true;
    }
  });

  return show;
}

export default function GuestProfile(props) {
  const { guest, pricing, schedule, showSchedule } = props;

  const showPricing = isShowPricing(pricing);
  const showGuestInfo =
    guest.bioLink || guest.biography || guest.socialNetworkLinks.length > 0;
  const showScheduleSection = showSchedule && schedule.tabs?.length > 0;

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        {guest.name && <h1 className={s.name}>{guest.name}</h1>}
        {guest.credits[guest.category] && (
          <div className={s.credits}>
            {guest.credits[guest.category].split(';').join(', ')}
          </div>
        )}
        {guest.appearingDates.length > 0 && (
          <div className={s.appearing}>
            <span className={s.label}>Appearing: </span>
            {guest.appearingDates.join(', ')}
          </div>
        )}
      </div>
      <div className={s.body}>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            {guest.images[guest.category] && (
              <div className={s.image}>
                <GuestPhoto
                  src={guest.images[guest.category]}
                  alt={guest.imageAlt}
                  withBorder
                />
              </div>
            )}
          </div>
          <div className="col-xs-12 col-sm-9">
            {showPricing && (
              <GuestSection heading="Pricing">
                <PricingItem heading="Autograph:" config={pricing.autograph} />
                <PricingItem
                  heading="Autograph Premium:"
                  config={pricing.autographPremium}
                />
                <PricingItem
                  heading="Autograph Premium Bulky:"
                  config={pricing.autographPremiumBulky}
                />
                <PricingItem heading="Photo Op:" config={pricing.photoOp} />
                <PricingItem heading="Selfie:" config={pricing.selfie} />
                <Disclaimer>Prices subject to change.</Disclaimer>
              </GuestSection>
            )}
            {showGuestInfo && (
              <GuestSection heading="Guest Info">
                {guest.bioLink && (
                  <Anchor to={guest.bioLink} className={s.brandLink}>
                    Check Out Their Bio
                  </Anchor>
                )}
                {guest.biography && (
                  <div className={s.biography}>{guest.biography}</div>
                )}
                {guest.socialNetworkLinks.length > 0 && (
                  <div className={s.socialNetworkLinks}>
                    {guest.socialNetworkLinks.map((link, index) => (
                      <Anchor
                        key={index}
                        to={link.url}
                        data-testid="socialNetworkLink"
                      >
                        <span className={cn(s.socialNetworkLink, link.icon)} />
                      </Anchor>
                    ))}
                  </div>
                )}
              </GuestSection>
            )}
            {showScheduleSection && (
              <GuestSection heading="Schedule">
                <Schedule schedule={schedule} guest={guest} />
              </GuestSection>
            )}
            <Disclaimer heading="Disclaimers">
              Guests subject to cancellation or schedule change, due to
              professional commitments.
              <br />
              Although most guests are available for the duration of the event,
              due to limited availability
              <br />
              some guests are only available for a portion of the event, i.e. a
              single day.
              <br />
              Appearance day(s) will be posted on the website as soon as we
              know.
              <br />
              All events have limited seating capacities and are offered on a
              first come, first served basis.
            </Disclaimer>
          </div>
        </div>
      </div>
    </div>
  );
}
